/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cra_Modal_SubtitleInputs */

const en_cra_modal_subtitle = /** @type {(inputs: Cra_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use this only if you have NOT arranged a new date with the customer. Otherwise use CAD.`)
};

const ja_cra_modal_subtitle = /** @type {(inputs: Cra_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顧客と新しい日付を合意していない場合のみ使用してください。合意済みの場合はCADを使用してください。`)
};

const fr_cra_modal_subtitle = /** @type {(inputs: Cra_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À utiliser uniquement si AUCUNE nouvelle date n'a été convenue avec le client. Sinon, utilisez CAD.`)
};

const de_cra_modal_subtitle = /** @type {(inputs: Cra_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur verwenden, wenn KEIN neuer Termin mit dem Kunden vereinbart wurde. Andernfalls bitte CAD verwenden.`)
};

/**
* | output |
* | --- |
* | "Use this only if you have NOT arranged a new date with the customer. Otherwise use CAD." |
*
* @param {Cra_Modal_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cra_modal_subtitle = /** @type {((inputs?: Cra_Modal_SubtitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cra_Modal_SubtitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cra_modal_subtitle(inputs)
	if (locale === "ja") return ja_cra_modal_subtitle(inputs)
	if (locale === "fr") return fr_cra_modal_subtitle(inputs)
	return de_cra_modal_subtitle(inputs)
});